export default [
  { id: 0, name: "未承認" },
  { id: 1, name: "レギュラー" },
  { id: 2, name: "プロ" },
  { id: 3, name: "マスター" },
  { id: 4, name: "スター" }
];
